import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router';
// import history from '../../history';
import CompanyValidation from './Validation';

import {
  saveCompany as saveCompanyAction,
  deleteCompany as deleteCompanyAction,
  changeForm as changeFormAction,
  setError as setErrorAction,
  deleteLogo as deleteLogoAction,
  uploadLogo as uploadLogoAction
} from './CompanyActions';

import loginActions from '../Login/LoginActions';

import style from './Company.module.css';

function Company(props) {
  const {
      company,
      companyId,
      saveCompany,
      setError,
      deleteCompany: deleteCompanyProp,
      changeForm,
      uploadLogo,
      deleteLogo,
      fetchCurUser,
      errors,
      isEdit,
      loading
  } = props;

  const navigate = useNavigate();
  const [logoFile, setLogoFile] = useState(null);

  function onSave(e) {
    e.preventDefault();

    const validationResult = validateCompany();

    setError(validationResult);
    const hasError = Object.keys(validationResult).length > 0;

    if (!hasError) {
      saveCompany(company, companyId).then(() => {
          navigate('/companies');
      });
    }
  }

  function deleteCompany(e) {
    e.preventDefault();

    if (window.confirm('Are you sure you want to delete this company?')) {
      deleteCompanyProp(companyId).then(() => {
          navigate('/companies');
      });
    }
  }

  function validateCompany() {
    return CompanyValidation(company, isEdit);
  }

  function changeField(e) {
    e.preventDefault();

    let { id, value } = e.target;

    value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;

    changeForm(id, value);
  }

  function uploadLogoFile(e) {
    e.preventDefault();
    fetchCurUser();

    uploadLogo(companyId, e.target.files[0])
      .then(() => {
        fetchCurUser();
      });
  }

  function deleteLogoFile(e) {
    e.preventDefault();
    deleteLogo(companyId)
      .then(() => {
        fetchCurUser();
      });
  }

  function error(err) {
    return <div className="text-danger">{err}</div>;
  }

  function goBack(e) {
    e.preventDefault();
    navigate('/companies');
  }

  const { 
    name, access_key, publicAccess, prefix, license_code, 
    maxExercises, maxSims, maxUsers, logoUrl, 
    hideCompanyName, hideMutualAid, hideBenchmarks
  } = company;

  return (
    <form>
      { errors.general && <div className="alert alert-danger">{errors.general}</div> }
      <div>
        <label>Logotype</label> <br/>
        <img src={ logoUrl } height="100px"/>
        <input style={{display:'none'}} id="logo-file-input" type="file" onChange={uploadLogoFile}/>
        <label className="btn btn-primary" htmlFor="logo-file-input">Upload logo image</label>
        &nbsp; <button className="btn btn-primary" onClick={deleteLogoFile}>Delete</button>
      </div>

      <div className={`mb-3 ${errors.name && 'has-error'}`}>
        <label className="control-label" htmlFor="name">Name</label>
        <input
          type="text"
          className="form-control"
          id="name"
          value={name || ''}
          onChange={changeField}
        />
        { errors.name && error(errors.name) }
      </div>

      <div className={`mb-3 ${errors.access_key && 'has-error'}`}>
        <label className="control-label" htmlFor="name">Access key</label>
        <input
          type="text"
          className="form-control"
          id="access_key"
          value={access_key || ''}
          onChange={changeField}
        />
        { errors.access_key && error(errors.access_key) }
      </div>

      <div className={`mb-3 ${errors.publicAccess && 'has-error'}`} style={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center'}}>
        <input
          type="checkbox"
          className="form-control form-check-input"
          id="publicAccess"
          checked={ !!publicAccess }
          onChange={changeField}
          style={{width: '30px', marginRight: 10}}
        />
        <label className="control-label" htmlFor="publicAccess" style={{marginTop: 10}}>Is public repository</label>
        { errors.publicAccess && error(errors.publicAccess) }
      </div>
      
      <div className={`mb-3 ${errors.hideCompanyName && 'has-error'}`} style={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center'}}>
        <input
          type="checkbox"
          className="form-control form-check-input"
          id="hideCompanyName"
          checked={ !!hideCompanyName }
          onChange={changeField}
          style={{width: '30px', marginRight: 10}}
        />
        <label className="control-label" htmlFor="hideCompanyName" style={{marginTop: 10}}>Hide company name</label>
        { errors.hideCompanyName && error(errors.hideCompanyName) }
      </div>
      
      <div className={`mb-3 ${errors.hideMutualAid && 'has-error'}`} style={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center'}}>
        <input
          type="checkbox"
          className="form-control form-check-input"
          id="hideMutualAid"
          checked={ !!hideMutualAid }
          onChange={changeField}
          style={{width: '30px', marginRight: 10}}
        />
        <label className="control-label" htmlFor="hideMutualAid" style={{marginTop: 10}}>Hide Mutual Aid</label>
        { errors.hideMutualAid && error(errors.hideMutualAid) }
      </div>
      
      <div className={`mb-3 ${errors.hideBenchmarks && 'has-error'}`} style={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center'}}>
        <input
          type="checkbox"
          className="form-control form-check-input"
          id="hideBenchmarks"
          checked={ !!hideBenchmarks }
          onChange={changeField}
          style={{width: '30px', marginRight: 10}}
        />
        <label className="control-label" htmlFor="hideBenchmarks" style={{marginTop: 10}}>Hide Benchmarks</label>
        { errors.hideBenchmarks && error(errors.hideBenchmarks) }
      </div>
      
      <div className={`mb-3 ${(errors.prefix && 'has-error') || ''}`}>
        <label className="control-label" htmlFor="prefix">Prefix</label>
        <input
          type="text"
          className="form-control"
          id="prefix"
          value={prefix || ''}
          onChange={changeField}
        />
        { errors.prefix && error(errors.prefix) }
      </div>
      <div className={`mb-3 ${(errors.license_code && 'has-error') || ''}`}>
        <label className="control-label" htmlFor="license_code">License Code</label>
        <input
          type="text"
          className="form-control"
          id="license_code"
          value={license_code || ''}
          onChange={changeField}
        />
        { errors.license_code && error(errors.license_code) }
      </div>
      <div className={`mb-3 ${(errors.maxExercises && 'has-error') || ''}`}>
        <label
          className="control-label"
          htmlFor="maxExercises"
        >Maximum number of web exercises</label>
        <input
          type="Number"
          className="form-control"
          id="maxExercises"
          value={maxExercises || ''}
          onChange={changeField}
        />
        { errors.maxExercises && error(errors.maxExercises) }
      </div>
      <div className={`mb-3 ${(errors.maxSims && 'has-error') || ''}`}>
        <label
          className="control-label"
          htmlFor="maxSims"
        >Sim storage in cloud account</label>
        <input
          type="Number"
          className="form-control"
          id="maxSims"
          value={maxSims || ''}
          onChange={changeField}
        />
        { errors.maxSims && error(errors.maxSims) }
      </div>
      <div className={`mb-3 ${(errors.maxUsers && 'has-error') || ''}`}>
        <label
          className="control-label"
          htmlFor="maxUsers"
        >Maximum active participants in exercises</label>
        <input
          type="Number"
          className="form-control"
          id="maxUsers"
          value={maxUsers || ''}
          onChange={changeField}
        />
        { errors.maxUsers && error(errors.maxUsers) }
      </div>
      <button className="btn btn-primary" onClick={onSave}>
        <i className="fas fa-check" /> Save
      </button>
      <button className={`btn btn-default ${style.btnMargin}`} onClick={goBack} >
        <i className="fas fa-mail-reply" /> Back
      </button>
      <button className="btn btn-danger float-end" onClick={deleteCompany}>
        <i className="fas fa-times" /> Delete company
      </button>
    </form>
  );
}

Company.propTypes = {
  company: PropTypes.object,
  companyId: PropTypes.string,
  errors: PropTypes.object,
  isEdit: PropTypes.bool,
  saveCompany: PropTypes.func,
  changeForm: PropTypes.func,
  setError: PropTypes.func,
  deleteCompany: PropTypes.func,
  fetchCurUser: PropTypes.func,
  uploadLogo: PropTypes.func,
  deleteLogo: PropTypes.func,
  loading: PropTypes.bool
};

const mapStateToProps = state => ({
  company: state.company.data,
  isEdit: state.company.isEdit,
  errors: state.company.errors,
});

const mapDispatchToProps = {
  saveCompany: saveCompanyAction,
  deleteCompany: deleteCompanyAction,
  changeForm: changeFormAction,
  setError: setErrorAction,
  uploadLogo: uploadLogoAction,
  deleteLogo: deleteLogoAction,
  fetchCurUser: loginActions.fetchCurUser
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Company);
